import { render } from "./ShareWindow.vue?vue&type=template&id=58c678d4&scoped=true"
import script from "./ShareWindow.vue?vue&type=script&lang=js"
export * from "./ShareWindow.vue?vue&type=script&lang=js"

import "./ShareWindow.vue?vue&type=style&index=0&id=58c678d4&scoped=true&lang=css"

import exportComponent from "/Users/adrianfraczak/Projects/Freaz/rk/rk.off-vue/rk.off-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c678d4"]])

export default __exports__